import { render, staticRenderFns } from "./ApplianceTypeCreate.vue?vue&type=template&id=02e2fba9"
import script from "./ApplianceTypeCreate.vue?vue&type=script&lang=js"
export * from "./ApplianceTypeCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports